var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-picker"},[_c('date-picker',{attrs:{"type":_vm.type,"range":true,"confirm":true,"clearable":false,"editable":false,"confirm-text":_vm.confirmText,"placeholder":_vm.placeholder,"value":_vm.value,"range-separator":_vm.rangeSeparator,"format":"DD-MMM-YYYY HH:mm"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }